module.exports = __webpack_public_path__ + "img/logo.628ee023.png";